<template>
    <font-awesome-icon v-if="isLoading" icon="spinner" spin/>
    <div v-else>
        <page-title :title="pageTitle" icon="pe-7s-note2">
            <template v-if="$store.getters.getFrontendParameterValue('process-products-sort', 'page-title-show-location-and-batch')" #subTitle>
                <location-link :location="location" hide-arrow/>
                <span v-html="pageSubTitle"/>
            </template>
        </page-title>

        <b-row v-if="!isSortingZoneSelected">
            <b-col>
                <b-card>
                    <b-card-title>SCAN ZONE</b-card-title>
                    <b-form @submit.prevent="submit">
                        <b-input type="text" v-model.trim="sortingZoneIdentifierInput" class="d-inline-block mr-2" ref="sortingZoneIdentifierInput"
                                 style="width:230px;"
                                 placeholder="Sorteerzone"
                                 required autofocus autocomplete="off"
                        />
                        <b-button variant="primary" type="submit">Kies</b-button>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>

        <component v-else v-bind:is="PROCESS_COMPONENTS[processType]"
                   :location="location"
                   :batchModelType="batchModelType"
                   :batchModelIdentifier="batchModelIdentifier"
                   :storageZoneIdentifier="sortingZoneIdentifierInput"
                   :processType="processType"
        />
    </div>
</template>

<script>
import PageTitle from "../../components/PageTitle.vue";
import LocationLink from "../../components/LocationLink.vue";
import {PRODUCT_PROCESS_TYPE_RETURN, PRODUCT_PROCESS_TYPE_SORT} from "../../data/productProcessType";
import ProcessSort from "./ProcessSort.vue"
import ProcessReturn from "./ProcessReturn.vue"
import {getLocationPropertyValue} from "../../helpers/locations";
import _ from "lodash";

export default {
    name: "ProcessStartWithBatch",
    components: {LocationLink, PageTitle},

    props: {
        locationTypeIdentifier: {type: String},
        locationIdentifier: {type: String},
        batchModelType: {type: String},
        batchModelIdentifier: {type: String},
        processType: {type: String},
    },

    data() {
        return {
            isLoading: true,
            isSortingZoneSelected: false,

            sortingZoneIdentifierInput: '',
            sortingZones: [],
            location: {},
            ordersInBatch: [],
        }
    },

    computed: {
        pageTitle() {
            let title = this.PROCESS_COMPONENTS[this.processType].methods.getPageTitle()
            if (this.isSortingZoneSelected) {
                title += `<br/>Zone: ${this.sortingZone.display_name}`
            }
            return title
        },
        pageSubTitle() {
            if (this.batchModelType === 'shipment-batch') {
                if (this.ordersInBatch.length === 1) {
                    const url = this.$router.resolve({
                        name: 'OrderDetailOverview',
                        params: {
                            salesOrderIdentifier: this.ordersInBatch[0]
                        },
                    }).href
                    return ` | order: <a href="${url}">${this.ordersInBatch[0]}</a>`
                }
                else {
                    const url = this.$router.resolve({
                        name: 'ShipmentBatchView',
                        params: {
                            locationTypeIdentifier: this.locationTypeIdentifier,
                            locationIdentifier: this.locationIdentifier,
                            batchIdentifier: this.batchModelIdentifier,
                        },
                    }).href
                    return ` | batch: <a href="${url}">${this.batchModelIdentifier}</a>`
                }
            } else if (this.batchModelType === 'goods-receipt') {
                const url = this.$router.resolve({
                    name: 'GoodsReceiptView',
                    params: {
                        locationTypeIdentifier: this.locationTypeIdentifier,
                        locationIdentifier: this.locationIdentifier,
                        goodsReceiptIdentifier: this.batchModelIdentifier,
                    },
                }).href
                return ` | goederenontvangst: <a href="${url}">${this.batchModelIdentifier}</a>`
            }
        },
        sortingZone() {
            return this.sortingZones.find(z => z.identifier === this.sortingZoneIdentifierInput)
        },
        PROCESS_COMPONENTS() {
            let components = {}
            components[PRODUCT_PROCESS_TYPE_SORT] = ProcessSort
            components[PRODUCT_PROCESS_TYPE_RETURN] = ProcessReturn
            return components
        },
    },

    mounted() {
        if (typeof this.PROCESS_COMPONENTS[this.processType] === 'undefined') {
            this.$alert('Onbekend process type', 'danger',  false)
            return
        }

        Promise.all([
            this.getSortingZones(),
            this.getLocation(),
            this.getOrdersInBatch(),
        ])
            .then(() => {
                this.isLoading = false

                const autofill = getLocationPropertyValue(this.location.location_properties, 'processProduct.autofillSortingZone')
                if (this.$store.state.config.general.environment === 'local' || autofill !== 0) {
                    this.sortingZoneIdentifierInput = this.sortingZones[0].identifier
                    if (autofill === 2) {
                        this.submit()
                    }
                }
            })
    },

    methods: {
        async getLocation() {
            return this.$http.get(`/api/rest/locations/${this.$route.params.locationTypeIdentifier}/${this.$route.params.locationIdentifier}`)
                .then(response => {
                    this.location = response.data
                })
        },
        async getSortingZones() {
            // FIXME: type en processtype zijn vooralsnog TOEVALLIG gelijk, maar ipc moet hier een mapping komen
            return this.$http.get(`/api/rest/locations/${this.locationTypeIdentifier}/${this.locationIdentifier}/storage-locations?type=${this.processType}`)
                .then(response => {
                    this.sortingZones = response.data
                })
        },
        async getOrdersInBatch() {
            if (this.batchModelType !== 'shipment-batch') {
                return Promise.resolve()
            }

            return this.$http.get(`/api/rest/locations/${this.locationTypeIdentifier}/${this.locationIdentifier}/dispatch-request-batches/${this.batchModelIdentifier}`, {
                params: {
                    include: [
                        'dispatch_requests:id,sales_order_id',
                        'dispatch_requests.sales_order:id,identifier',
                    ].join(';')
                }
            })
                .then(response => {
                    this.ordersInBatch = _.chain(response.data.dispatch_requests)
                        .uniqBy(drq => drq.sales_order_id)
                        .map(drq => drq.sales_order?.identifier)
                        .value()

                })
        },
        submit() {
            if (!this.sortingZones.some(zone => zone.identifier === this.sortingZoneIdentifierInput)) {
                this.sortingZoneIdentifierInput = ''
                return this.$alert('Sorteerzone niet gevonden', 'warning')
            }

            this.isSortingZoneSelected = true
        },
    },
}
</script>

<style scoped>

</style>
